import React from "react";
import TextImageBanner from "../../components/common/TextImageBanner";
import ContactLocation from "../../components/UserComponents/contact/ContactLocation";
import ContactGetInTouch from "../../components/UserComponents/contact/ContactGetInTouch";
import ContactMap from "../../components/UserComponents/contact/ContactMap";
import OurCenters from "../../components/UserComponents/home/OurCenters";
import image from "../../Assets/Home/MainHome/home3.png";
const Contact = () => {
  return (
    <div>
      <TextImageBanner
        label="contact"
        bgImage={[
          `${image}`,
          `${image}`,
          `${image}`,
        ]}
      />
      {/* <ContactLocation /> */}
       <OurCenters />
      <ContactGetInTouch />
      <ContactMap />
    </div>
  );
};

export default Contact;
